
export function modulSort(onlineusers, type){
  switch (type) {
    case "n":
      onlineusers.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      break;
    case "a":
      onlineusers.sort(function (a, b) {
        return a.alter -b.alter;
      });
      break;
    case "r":
      onlineusers.sort(function (a, b) {
        if (a.region < b.region) {
          return -1;
        }
        if (a.region > b.region) {
          return 1;
        }
        return 0;
      });
      break;
  }
}



// WEBPACK FOOTER //
// ./src/firebase/GlobalFunctions.js